import { URLSearchParams } from 'url';
import {
    DataDogClickSourceType,
    DataDogClickMediumType,
    DataDogClickTypeType,
    DATA_DOG_CLICK_SOURCE_TYPES,
    DATA_DOG_CLICK_MEDIUM_TYPES,
    DATA_DOG_CLICK_TYPE_TYPES
} from '../types/DataDogTypes';

export default function checkValidUtmValues(searchParams: URLSearchParams) {
    try {
        const utmSource = searchParams.get('utm_source') as DataDogClickSourceType;
        const hasValidUtmSource = DATA_DOG_CLICK_SOURCE_TYPES.includes(utmSource);

        const utmMedium = searchParams.get('utm_medium') as DataDogClickMediumType;
        const hasValidUtmMedium = DATA_DOG_CLICK_MEDIUM_TYPES.includes(utmMedium);

        const utmType = searchParams.get('utm_type') as DataDogClickTypeType;
        const hasValidUtmType = DATA_DOG_CLICK_TYPE_TYPES.includes(utmType);

        const hasValidUtmValues = (hasValidUtmSource && hasValidUtmMedium && hasValidUtmType);

        return ({
            hasValidUtmValues,
            utmSource: hasValidUtmSource ? utmSource : null,
            utmMedium: hasValidUtmMedium ? utmMedium : null,
            utmType: hasValidUtmType ? utmType : null
        });
    } catch (error) {
        console.error('Error checking UTM values:', error);
        return {
            hasValidUtmValues: false,
            utmSource: null,
            utmMedium: null,
            utmType: null
        };
    }
}
